export enum ApplicantMode {
  ApplicantModeNormal = 'Normal',
  ApplicantModeSwap = 'SwapApplicants',
  ApplicantModeMainApplicant = 'OnlyMainApplicant',
  ApplicantModeCoApplicant = 'OnlyCoApplicant',
}
